module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "self-support-page"
  }, [_c('zyheader'), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "warpper"
  }, [_c('div', {
    staticClass: "mod-focus"
  }, [_c('div', {
    staticClass: "mod-focus-menu"
  }, [_c('h3', [_vm._v("全部商品分类")]), _vm._v(" "), _c('div', {
    staticClass: "nav-class"
  }, [_c('ul', _vm._l((_vm.storeNavigation), function(row, $index) {
    return (row.storeCatPid == '0') ? _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            tab: 2,
            store_id: row.storeId,
            pid: row.storeCatPid,
            acid: row.storeCatPid
          }
        }
      }
    }, [_vm._v("\n                " + _vm._s(row.storeCatName) + " "), _c('b', {
      staticClass: "right"
    }, [_c('i', {
      staticClass: "right-arrow1"
    }), _c('i', {
      staticClass: "right-arrow2"
    })])])], 1) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "nav-more"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/shop',
        query: {
          tab: 2,
          store_id: 1
        }
      }
    }
  }, [_vm._v("\n            更多分类>>\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mod-focus-swipe",
    attrs: {
      "id": "focus-swipe"
    }
  }, [_c('banner', {
    attrs: {
      "data": _vm.zyshgBannerAdv.advList,
      "size": _vm.zyshgBannerAdv.adColumn
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mod-focus-sidebar"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.zyshgdbycAdv.url,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.zyshgdbycAdv.atturl,
      "alt": "暂无图片",
      "width": "240px",
      "height": "418px;"
    }
  })])], 1)]), _vm._v(" "), _c('gd-selected', {
    attrs: {
      "data": {
        b: _vm.ddjxnshang,
        s: _vm.ddjxnxia
      }
    }
  }), _vm._v(" "), _c('boutique-discount', {
    attrs: {
      "data": _vm.jpzjdata
    }
  }), _vm._v(" "), _c('not-enough', {
    attrs: {
      "data": _vm.hmggData
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5948caa4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/self-owned-mall/index/index.vue
// module id = 1610
// module chunks = 1